function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import classNames from 'classnames';
import T from 'prop-types';
import React from 'react';
/**
 * Description placeholder
 *
 * @export
 * @param {string} label
 * @param {object} svgProps - object: should be <svg> tag attributes e.g. width, height, fill etc
 * @param {object} textProps - object: should be <text> tag attributes e.g. x, y etc
 * @param {string} textClass - additional/override class
 * @returns
 */ export default function OutlinedText(param) {
    var label = param.label, svgProps = param.svgProps, textProps = param.textProps, textClass = param.textClass, svgClass = param.svgClass;
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        className: classNames('svgOutlined', svgClass)
    }, svgProps), /*#__PURE__*/ React.createElement("text", _object_spread({
        dominantBaseline: "hanging",
        className: classNames('svgText', textClass)
    }, textProps), label));
}
OutlinedText.propTypes = {
    label: T.string.isRequired,
    textClass: T.string,
    svgProps: T.object.isRequired,
    textProps: T.object,
    svgClass: T.string
};
OutlinedText.defaultProps = {
    textClass: '',
    textProps: {
        x: 2,
        y: 2
    },
    svgProps: {
        width: '48px'
    },
    svgClass: 'position-absolute'
};
